import { Variants } from 'framer-motion';
import { ModalAnimationType, IAnimationOptions } from './types';

export function getModalVariantAnimations({
  childrenEnterDelay: enterDelay,
  childrenExitDelay: exitDelay,
}: IAnimationOptions): Record<ModalAnimationType, Variants> {
  return Object.freeze({
    slideUpFromBottom: {
      hidden: {
        y: '100vh',
        opacity: 0,
      },
      visible: {
        y: '0',
        opacity: 1,
        transition: {
          type: 'spring',
          damping: 50,
          stiffness: 600,
          delay: enterDelay ?? 0,
        },
      },
      exit: {
        y: '100vh',
        opacity: 0,
        transition: {
          duration: 0.2,
          delay: exitDelay ?? 0,
        },
      },
    },
    slideDownFromTop: {
      hidden: {
        y: '-100vh',
        opacity: 0,
      },
      visible: {
        y: 0,
        opacity: 1,
        transition: {
          duration: 0.1,
          type: 'spring',
          damping: 50,
          stiffness: 600,
          delay: enterDelay ?? 0,
        },
      },
      exit: {
        y: '100vh',
        opacity: 0,
        transition: {
          duration: 0.2,
          delay: exitDelay ?? 0,
        },
      },
    },
    none: {},
  });
}
